import React, { Component } from 'react';
import '../../css/App.css';
import { SumerianScene, LoadingScreen } from '../'; // our custom SumerianScene component

class SumerianSceneParent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sceneController: null
    };
  }

  sceneLoaded(sceneController) {
    this.setState({
      loading: false,
      sceneController
    });
  }

  render() {
    return (
      <div className="App">
        {this.state.loading && (
          <div style={{ paddingTop: '20vh' }}>
            <LoadingScreen />
            { }
          </div>
        )}
        <div style={{ visibility: this.state.loading && 'hidden' }}>
          <SumerianScene
            scene="nsvpo"
            onLoaded={(controller) => this.sceneLoaded(controller)}
          />
        </div>
      </div>
    );
  }
}

export default SumerianSceneParent;
